import { HttpErrorResponse } from "@angular/common/http";

export interface TutorDeleteState {
    deleteTutorResult: boolean;
    deleteTutorLoader: boolean;
    deleteTutorError: HttpErrorResponse;
}

export const initialTutorDeleteState: TutorDeleteState = {
    deleteTutorResult: null,
    deleteTutorLoader: false,
    deleteTutorError: null,
}